export type AuthorityPath = "probate" | "administration" | "sea";

export function getAuthorityPath(
  hasWill: string | null | undefined,
  isSmallEstate: boolean,
): AuthorityPath | null {
  if (!hasWill) return null;
  if (hasWill === "yes") return "probate";
  if (isSmallEstate) return "sea";
  if (hasWill === "no") return "administration";
  return null;
}
